import React from "react";

export default function TagBadge({children, bgColor = null}) {
  const grayGradient = "linear-gradient(90deg, #7f8c8d, #95a5a6)";

  const background = bgColor || grayGradient;

  return (
    <div
      className="flex justify-center text-white font-extralight items-center h-6 rounded px-2"
      style={{background}}
    >
      {children}
    </div>
  );
}
